import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
const formatToDateString = (date) => date.format('YYYY-MM-DDTHH:mm:ssZ').replace('+00:00', 'Z');
export const getFrom = (now, range) => {
    if (range === 7) {
        return formatToDateString(now.subtract(7 - 1, 'days').startOf('day'));
    }
    if (range === 30) {
        return formatToDateString(now.subtract(30 - 1, 'days').startOf('day'));
    }
    return formatToDateString(now.startOf('day'));
};
export const getTo = (now) => formatToDateString(now.endOf('day'));
export const getPrecision = (range) => {
    if (range === 1) {
        return 'HOUR';
    }
    return 'DAY';
};
export const getRangeQueryParam = (range) => {
    if (range === 7) {
        return 'last7days';
    }
    if (range === 30) {
        return 'last30days';
    }
    return 'today';
};
export const getDateFormat = (precision) => {
    return precision === 'HOUR' ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY';
};
